import {createSelector} from 'reselect';
import props from '../props';

export default createSelector(
    props.user.user,
    props.user.buttons.changeAvatar,
    (user, changeAvatarButton) => {
        return {
            user,
            changeAvatarButton
        }
    }
)